import AircraftPrice from './AircraftPrice';
export default AircraftPrice;
